var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakeATour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 130,
    viewBox: "0 0 167 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M160.358 75.8018C160.358 33.9213 126.389 0 84.4489 0C42.5091 0 8.53979 33.9213 8.53979 75.8018C8.53979 86.9825 11.0068 97.5948 15.3716 107.07H153.716C157.891 97.5948 160.358 86.9825 160.358 75.8018Z",
    fill: "#05C3DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48865 107.07H157.511",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.948853 107.07H5.69317",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.307 107.07H166.051",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0037 48.134H41.3708C37.006 48.134 33.5901 51.7346 33.5901 55.9037V103.469L89.0037 48.134Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.229 113.513H40.232C36.4365 113.513 33.4001 110.481 33.4001 106.691V54.9562C33.4001 51.1661 36.4365 48.134 40.232 48.134H118.229C122.024 48.134 125.06 51.1661 125.06 54.9562V106.691C125.06 110.481 122.024 113.513 118.229 113.513Z",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.28 113.513C121.644 113.513 125.06 109.912 125.06 105.743V103.09H33.4001V105.743C33.4001 110.102 37.0058 113.513 41.1808 113.513H117.28Z",
    fill: "white",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3371 114.013L86.538 123.436H72.102L73.1314 114.013H85.3371Z",
    fill: "white",
    stroke: "#006894"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1058 123.936H71.5444L72.6831 113.513H85.7774L87.1058 123.936Z",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4047 129.052H62.2456C62.2456 126.21 64.5229 123.746 67.5592 123.746H91.0911C93.9377 123.936 96.4047 126.21 96.4047 129.052Z",
    fill: "white",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.82 88.688H59.0196C56.5526 88.688 54.4651 86.6035 54.4651 84.1399V38.8484H130.374V83.9504C130.374 86.6035 128.287 88.688 125.82 88.688Z",
    fill: "white",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.374 38.8484H54.4651V27.6676C54.4651 25.2041 56.5526 23.1195 59.0196 23.1195H125.82C128.287 23.1195 130.374 25.2041 130.374 27.6676V38.8484Z",
    fill: "white",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2457 33.7318C63.713 33.7318 64.9025 32.544 64.9025 31.0787C64.9025 29.6135 63.713 28.4257 62.2457 28.4257C60.7784 28.4257 59.5889 29.6135 59.5889 31.0787C59.5889 32.544 60.7784 33.7318 62.2457 33.7318Z",
    fill: "#05C3DE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6832 33.7318C74.1505 33.7318 75.34 32.544 75.34 31.0787C75.34 29.6135 74.1505 28.4257 72.6832 28.4257C71.2159 28.4257 70.0264 29.6135 70.0264 31.0787C70.0264 32.544 71.2159 33.7318 72.6832 33.7318Z",
    fill: "#05C3DE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3104 33.7318C84.7777 33.7318 85.9672 32.544 85.9672 31.0787C85.9672 29.6135 84.7777 28.4257 83.3104 28.4257C81.8431 28.4257 80.6536 29.6135 80.6536 31.0787C80.6536 32.544 81.8431 33.7318 83.3104 33.7318Z",
    fill: "#05C3DE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5366 64.9999H79.8946C78.7559 64.9999 77.9968 64.2419 77.9968 63.1048V56.4722C77.9968 55.3352 78.7559 54.5771 79.8946 54.5771H86.5366C87.6752 54.5771 88.4343 55.3352 88.4343 56.4722V63.1048C88.4343 64.2419 87.6752 64.9999 86.5366 64.9999Z",
    fill: "#05C3DE",
    fillOpacity: 0.25,
    stroke: "#05C3DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.616 64.9999H96.9739C95.8353 64.9999 95.0762 64.2419 95.0762 63.1048V56.4722C95.0762 55.3352 95.8353 54.5771 96.9739 54.5771H103.616C104.755 54.5771 105.514 55.3352 105.514 56.4722V63.1048C105.514 64.2419 104.755 64.9999 103.616 64.9999Z",
    fill: "#05C3DE",
    fillOpacity: 0.25,
    stroke: "#05C3DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.696 64.9999H113.864C112.725 64.9999 111.966 64.2419 111.966 63.1048V56.4722C111.966 55.3352 112.725 54.5771 113.864 54.5771H120.506C121.644 54.5771 122.404 55.3352 122.404 56.4722V63.1048C122.593 64.2419 121.644 64.9999 120.696 64.9999Z",
    fill: "#05C3DE",
    fillOpacity: 0.25,
    stroke: "#05C3DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5366 80.7289H79.8946C78.7559 80.7289 77.9968 79.9709 77.9968 78.8338V72.2012C77.9968 71.0642 78.7559 70.3062 79.8946 70.3062H86.5366C87.6752 70.3062 88.4343 71.0642 88.4343 72.2012V78.8338C88.4343 79.9709 87.6752 80.7289 86.5366 80.7289Z",
    fill: "#05C3DE",
    fillOpacity: 0.25,
    stroke: "#05C3DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.616 80.7289H96.9739C95.8353 80.7289 95.0762 79.9709 95.0762 78.8338V72.2012C95.0762 71.0642 95.8353 70.3062 96.9739 70.3062H103.616C104.755 70.3062 105.514 71.0642 105.514 72.2012V78.8338C105.514 79.9709 104.755 80.7289 103.616 80.7289Z",
    fill: "#05C3DE",
    fillOpacity: 0.25,
    stroke: "#05C3DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.696 80.7289H113.864C112.725 80.7289 111.966 79.9709 111.966 78.8338V72.2012C111.966 71.0642 112.725 70.3062 113.864 70.3062H120.506C121.644 70.3062 122.404 71.0642 122.404 72.2012V78.8338C122.593 79.9709 121.644 80.7289 120.696 80.7289Z",
    fill: "#05C3DE",
    fillOpacity: 0.25,
    stroke: "#05C3DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7854 49.4605H64.1433C63.0047 49.4605 62.2456 48.7025 62.2456 47.5655V46.0495C62.2456 44.9124 63.0047 44.1544 64.1433 44.1544H70.7854C71.924 44.1544 72.6831 44.9124 72.6831 46.0495V47.5655C72.6831 48.513 71.924 49.4605 70.7854 49.4605Z",
    fill: "#05C3DE",
    fillOpacity: 0.25,
    stroke: "#05C3DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.696 49.4605H79.8946C78.7559 49.4605 77.9968 48.7025 77.9968 47.5655V46.0495C77.9968 44.9124 78.7559 44.1544 79.8946 44.1544H120.696C121.834 44.1544 122.593 44.9124 122.593 46.0495V47.5655C122.593 48.513 121.645 49.4605 120.696 49.4605Z",
    fill: "#05C3DE",
    fillOpacity: 0.25,
    stroke: "#05C3DE",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2456 54.5771H72.6831",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2456 59.8834H72.6831",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2456 65H72.6831",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2456 70.3062H72.6831",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2456 75.6122H72.6831",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2456 80.7289H68.8876",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147.454 109.344C147.074 110.67 146.315 110.86 145.746 109.533L137.206 88.8775C136.637 87.5509 137.206 86.9824 138.534 87.5509L159.22 96.0786C160.548 96.6472 160.548 97.4052 159.03 97.7842L152.388 99.4897C151.059 99.8687 149.541 101.385 149.162 102.711L147.454 109.344Z",
    fill: "#05C3DE",
    stroke: "#05C3DE",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3252 109.344C79.954 109.344 80.4638 108.835 80.4638 108.207C80.4638 107.579 79.954 107.07 79.3252 107.07C78.6963 107.07 78.1865 107.579 78.1865 108.207C78.1865 108.835 78.6963 109.344 79.3252 109.344Z",
    stroke: "#006894",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeATour);
export default __webpack_public_path__ + "static/media/take-a-tour.38541b682be0b81a3362c164adef3b81.svg";
export { ForwardRef as ReactComponent };